import React from 'react';
import { bool, object, objectOf } from 'prop-types';
import { connect } from 'react-redux';
import FitFinder from 'yoda-site-components/lib/components/FitFinder/FitFinder';
import { getInteractiveVizNavFromIrisDataState } from '../../selectors/InteractiveVizNav';

const InteractiveVizNav = ({ deviceType = { isDesktop: true }, interactiveVizNav = {} }) => {
    return <FitFinder deviceType={deviceType} interactiveVizNav={interactiveVizNav} />;
};

InteractiveVizNav.propTypes = {
    deviceType: objectOf(bool).isRequired,
    interactiveVizNav: object.isRequired,
};

export const mapStateToProps = (state, selfProps) => ({
    interactiveVizNav: getInteractiveVizNavFromIrisDataState(state, selfProps),
});

export default connect(mapStateToProps)(InteractiveVizNav);
